module.exports = __webpack_public_path__ + "static/media/main idea.0d37b980.mp3";